<template>
    <div>
        <div class="c_right">
            <div class="kefu" @click="gotokefu()">
                <!-- <img src="~@/assets/r_kefu.png"> -->
                <div class="imgs"></div>
                <span>在线客服</span>
            </div>
            <div class="help" @click="goTo('help?url=help')">
                <div class="imgs"></div>
                <span>帮助中心</span>
            </div>
            <div class="phone">
                <div class="imgs"></div>
                <span>电话咨询</span>
                <div class="content">
                    <div class="left">
                        <img src="~@/assets/r_phone_h.png">
                    </div>
                    <div class="right">
                        <div class="one">咨询电话</div>
                        <div class="two">请拨打</div>
                        <div class="three">0760-88929118</div>
                        <div class="three">18022118773</div>
                    </div>
                </div>
            </div>
            
        </div>

        <div class="gototop" @click="gototop()">
            <img src="~@/assets/top.png">
            <span>返回顶部</span>
        </div>


        <el-dialog
            title="联系客服"
            :visible.sync="dialogVisible"
            width="550px"
            class="dialog"
            :close-on-click-modal='false'
            :before-close="handleClose"
            >
            <div class="top_title">
                <div class="title">HI，欢迎来到中一广告策划官网！</div>
                <div class="des">您可以直接拨打电话联系客服，也可以在线进行沟通。</div>
                <div class="right"><img src="~@/assets/ip.png"></div>
            </div>
            <div class="ws_content" ref="viewBox">
                <div class="time_c">
                    <div class="time">{{time}}</div>
                </div>
                <div class="list">
                    <div class="con">你好，我叫小一，欢迎您光临中一广告策划官网，请问有什么可以帮助到您？</div>
                </div>

                <div class="list" :class="vo.type == 2 ? 'kehu' : ''" v-for="(vo,i) of content" :key="i">
                    <div class="con">{{vo.con}}</div>
                </div>
                

                <div class="shuru">
                    <el-input
                        class="con_in"
                        v-model="kehu_con"
                        @keyup.enter.native="chuanson()"
                        clearable>
                    </el-input>
                     <el-button class="send" type="success" @click="chuanson()">发送</el-button>
                </div>
            </div>
            
        </el-dialog>

    </div>
</template>
      
<script>
export default {
    name: 'right',
    components: {
        
    },
    data () {
        return {
            websock: null,
            dialogVisible:false,
            time:'',
            content:[
               
            ],
            kehu_con:''
        }
    },
    mounted () {
        this.gettime()
    },
    created() {
        
    },
    destroyed() {
        this.websock.close() //离开路由之后断开websocket连接
    },
  methods:{
    refresh() {
        setTimeout(() => {
                this.viewBox = this.$refs.viewBox
                this.viewBox.scrollTop = this.viewBox.scrollHeight
        }, 100)
    },
    handleClose(){
        this.dialogVisible = false
        this.websock.close()
        this.content = []
    },
    goTo(url){
        this.$router.push(url);
    },
    gototop(){
        document.querySelector('#app').scrollIntoView(true)
    },
    
    //kefu
    gotokefu(){
        this.dialogVisible = true
        this.gettime()
        this.initWebSocket();
    },
    gettime(){
        var _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
        _this.time = mm+'月'+dd+'日 '+hh+':'+mf;
            
    },
    chuanson(){
        if(this.kehu_con == ''){
            this.$message({
            message: '回复信息不能为空哦',
            type: 'warning'
            });
            return false
        }
        this.websocketsend(JSON.stringify(this.kehu_con));
        this.content.push({
            con:this.kehu_con,
            type:2
        })
        this.kehu_con = ''
        this.refresh()
    },
    initWebSocket(){ //初始化weosocket
        const wsuri = "ws://ws.zsone.net:8282/?type=1";
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
    },
    websocketonopen(){ //连接建立之后执行send方法发送数据
        // let actions = {"test":"12345"};
        // this.websocketsend(JSON.stringify(this.kehu_con));
    },
    websocketonerror(){//连接建立失败重连
        this.initWebSocket();
    },
    websocketonmessage(e){ //数据接收
        // console.log()
        // const redata = JSON.parse(e.data);
        if(e.data == '客服还未上线'){
            this.content.push({
                con:e.data,
                type:1
            }) 
        }else if(e.data == '现在客服繁忙请稍后哦'){
            this.content.push({
                con:e.data,
                type:1
            }) 
        }else{
            this.content.push({
                con:JSON.parse(e.data),
                type:1
            })
        }
        this.refresh()
    },
    websocketsend(Data){//数据发送
        this.websock.send(Data);
        
    },
    websocketclose(e){  //关闭
        console.log('断开连接',e);
    },
  },
  
}
</script>

<style lang='scss' scoped>
$zycolor:#CF2C2E;
.c_right{
    position: fixed;
    right:10px;
    top:30%;
    // height: 300px;
    width: 100px;
    border:1px solid #a0a0a0;
    border-radius: 5px;
    // padding:5px;
    box-sizing: border-box;
    .kefu ,.help,.phone{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding:20px 0;
        cursor: pointer;
        background: #fff;
    }
    .kefu{
        
        .imgs{
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
            background: url('~@/assets/r_kefu.png') no-repeat;
            background-size: 100%;
        }
    }
    .kefu:hover{
        background: #CF2C2E;
        .imgs{
            background: url('~@/assets/r_kefu_h.png') no-repeat;
            background-size: 100%;
        }
        span{
            color:#fff;
        }
    }
    .help{
        border-top:1px solid #a0a0a0;
        .imgs{
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
            background: url('~@/assets/r_help.png') no-repeat;
            background-size: 100%;
        }
    }
    .help:hover{
        background: #CF2C2E;
        .imgs{
            background: url('~@/assets/r_help_h.png') no-repeat;
            background-size: 100%;
        }
        span{
            color:#fff;
        }
    }
    .phone{
        border-top:1px solid #a0a0a0;
        position: relative;
        .imgs{
            width: 40px;
            height: 40px;
            margin-bottom: 5px;
            background: url('~@/assets/r_phone.png') no-repeat;
            background-size: 100%;
        }
        .content{
            position: absolute;
            top:0;
            right:140px;
            background: #CF2C2E;
            display: none;
            justify-content: space-between;
            padding:20px;
            border-radius: 10px;
            width: 200px;
            color:#fff;
            img{
                width: 30px;
                height: 30px;
            }
            .left{

            }
            .right{
                text-align: left;
                .one{
                    margin-bottom: 5px;
                }
                .two{
                    margin-bottom: 15px;
                }
                .three{
                    margin-bottom: 10px;
                    font-size: 22px;
                }
            }
        }
    }
    .phone:hover{
        background: #CF2C2E;
        .imgs{
            background: url('~@/assets/r_phone_h.png') no-repeat;
            background-size: 100%;
        }
        span{
            color:#fff;
        }
        .content{
             display: flex;
        }
    }
    
}

.gototop{
    position: fixed;
    right:10px;
    top:67%;
    width: 100px;
    // border:1px solid #a0a0a0;
    border-radius: 5px;
    box-sizing: border-box;
    padding:20px 0;
    background: $zycolor;
    color:#fff;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
        width: 40px;
        height: 40px;
        margin-bottom: 5px;
    }
}

.top_title{
    width: 100%;
    background: #CE2B2D;
    display: flex;
    position: relative;
    flex-direction: column;
    text-align: left;
    padding:0 20px;
    box-sizing: border-box;
    height: 200px;
    .title{
        color:#fff;
        margin-top:20px;
        font-size: 22px;
    }
    .des{
        color: #fff;
        margin-top:10px;
    }
    .right{
        position:absolute;
        right:10px;
        bottom: 20px;
        width: 150px;
        height: 150px;
        img{
            width: 150px;
            height: 150px;
        }
    }
}
.ws_content{
    width: 100%;
    height: 500px;
    background: #eeeeee;
    padding:20px 10px 50px 10px;
    box-sizing: border-box;
    overflow-y: scroll;
    
    .time_c{
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
    }
    .time{
        background: #D9D8D8;
        padding:5px 10px;
        width: 150px;
        text-align: center;
        box-sizing: border-box;
        border-radius: 30px;
    }
    .list{
        
        border-radius: 15px;
        // width: 400px;
        text-align: left;
        display: flex;
        box-sizing: border-box;
        margin-bottom: 20px;
        width: 100%;
        .con{
            border-radius: 15px;
            padding:10px 20px;
            background: #fff;
            max-width: 300px;
        }
    }
    .kehu{
        display: flex;
        flex-direction:row-reverse;
        .con{
            border-radius: 15px;
            padding:10px 20px;
            background: $zycolor;
            background: $zycolor;
            color: #fff;
        }
    }
}
.shuru{
    position:absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #eee;
    height: 40px;
    display: flex;
    .con_in{
        width: 80%;
        border-radius: 0;
        input{
            border-radius: 0;
        }
    }
    .send{
        width: 20%;
        border-radius: 0;
    }
}
</style>

<style>
.el-dialog__body{
    padding: 0!important;
}
.el-dialog__header{
    padding:15px 20px 10px;
}
</style>